import React, { useState, useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [params] = useSearchParams();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  // Pre-fill email if provided via ?email=... (from invite emails)
  useEffect(() => {
    const q = params.get("email");
    if (q) setEmail(q.trim().toLowerCase());
  }, [params]);

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    const r = await login(email.trim().toLowerCase(), password);
    setLoading(false);
    if (r.ok) nav("/dashboard");
    else setError(r.error || "Invalid credentials");
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-2 bg-[#050505]" data-testid="login-page">
      <div className="hidden lg:block relative overflow-hidden">
        <img alt="" src="https://images.pexels.com/photos/13609018/pexels-photo-13609018.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1000&w=1200"
             className="absolute inset-0 w-full h-full object-cover opacity-40" />
        <div className="absolute inset-0 bg-gradient-to-br from-black via-black/70 to-transparent" />
        <div className="relative h-full flex flex-col justify-between p-12">
          <div className="crest">
            <span className="text-[#D4AF37] text-2xl leading-none">◇</span>
            <span>The Boardroom</span>
          </div>
          <div>
            <h1 className="font-display text-6xl leading-[1] text-white mb-6">
              Trade like the<br/><em className="text-[#D4AF37] not-italic font-normal">house</em>, not the crowd.
            </h1>
            <div className="gold-divider w-32 my-6" />
            <p className="text-neutral-400 max-w-md font-body">
              A private curriculum for serious Forex &amp; Futures operators. Invite-only.
              Every page you read is stamped with your name.
            </p>
          </div>
          <div className="overline">◇ Private Trading Syndicate ◇ Est. 2026</div>
        </div>
      </div>

      <div className="flex items-center justify-center p-8">
        <form onSubmit={submit} className="w-full max-w-md" data-testid="login-form">
          <div className="crest lg:hidden mb-8">
            <span className="text-[#D4AF37] text-xl">◇</span><span>The Boardroom</span>
          </div>
          <p className="overline mb-3">Members Entrance</p>
          <h2 className="font-display text-4xl mb-2">Sign in.</h2>
          <p className="text-neutral-500 text-sm mb-10">Access is invite-only. No public registration.</p>

          <label className="overline mb-2 block">Email</label>
          <input data-testid="login-email" type="email" required autoFocus={!email}
                 value={email} onChange={(e) => setEmail(e.target.value)}
                 className="input-boardroom mb-6" placeholder="you@example.com" />

          <label className="overline mb-2 block">Password</label>
          <input data-testid="login-password" type="password" required autoFocus={!!email}
                 value={password} onChange={(e) => setPassword(e.target.value)}
                 className="input-boardroom mb-4" placeholder="••••••••" />

          {error && (
            <div data-testid="login-error" className="text-sm text-red-400 border border-red-900/60 bg-red-950/30 px-3 py-2 mb-4">
              {error}
            </div>
          )}

          <button data-testid="login-submit" type="submit" disabled={loading}
                  className="btn-gold w-full mt-4">
            {loading ? "Verifying…" : "Enter The Boardroom"}
          </button>

          <div className="gold-divider mt-12 mb-4" />
          <p className="text-xs text-neutral-500 text-center">
            Lost access? Contact your Boardroom administrator.
          </p>
        </form>
      </div>
    </div>
  );
}
